import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandMark from "../../components/BrandMark";

export default function LegalLayout({ title, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen bg-bg-void text-ink-primary" data-testid={testId}>
      <header className="border-b border-white/5">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-link">
            <BrandMark size={28} />
            <span className="font-semibold tracking-tight">StudioOps Food</span>
          </Link>
          <Link
            to="/"
            className="text-xs text-ink-muted hover:text-ink-primary flex items-center gap-1.5 transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={14} /> Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-5 md:px-8 py-12 md:py-16">
        <div className="mb-10">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-2" data-testid="legal-title">
            {title}
          </h1>
          {lastUpdated && (
            <p className="text-xs text-ink-muted">Stand: {lastUpdated}</p>
          )}
        </div>

        <article className="legal-content text-sm text-ink-primary/90 leading-relaxed space-y-6">
          {children}
        </article>
      </main>

      <footer className="border-t border-white/5 mt-10">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-6 flex flex-wrap gap-4 text-xs text-ink-muted">
          <Link to="/impressum" className="hover:text-ink-primary transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-ink-primary transition-colors">Datenschutz</Link>
          <Link to="/agb" className="hover:text-ink-primary transition-colors">AGB</Link>
          <span className="ml-auto">© 2026 StudioOps Food</span>
        </div>
      </footer>
    </div>
  );
}

export const Section = ({ title, children }) => (
  <section className="space-y-3">
    {title && (
      <h2 className="text-lg md:text-xl font-semibold text-ink-primary mt-8 mb-2">{title}</h2>
    )}
    <div className="space-y-3 text-ink-primary/85">{children}</div>
  </section>
);
